import React from "react";
import classNames from "classnames";
import {Manager, Popper, Target} from "react-popper";
import {ClickAwayListener, Grow, Hidden, IconButton, MenuItem, MenuList, Paper, withStyles} from "material-ui";
import {Notifications, Person} from "@material-ui/icons";

import {CustomInput} from "components";

import headerLinksStyle from "assets/jss/material-dashboard-react/headerLinksStyle";
import {connect} from "react-redux";
import {oktaSignIn} from "../../index";

class HeaderLinksPage extends React.Component {
    state = {
        open: false,
        openLogout: false
    };
    handleClick = () => {
        this.setState({open: !this.state.open});
    };
    handleClickLogout = () => {
        this.setState({openLogout: !this.state.openLogout});
    };
    handleClose = () => {
        this.setState({open: false});
        this.setState({openLogout: false});
    };
    handleLogout = () => {
        oktaSignIn.signOut(() => {
            //TODO: Decorate HeaderLinksPage using withAuth(), to logout user (clear tokens)
            //this.props.auth.logout('/');
            oktaSignIn.tokenManager && oktaSignIn.tokenManager.clear();
            window.location = "/";
        });
    };

    render() {
        const {classes} = this.props;
        const {open} = this.state;
        const {openLogout} = this.state;
        return (
            <div>
                <Manager style={{display: "inline-block"}}>
                    <Target>
                        <IconButton
                            color="inherit"
                            aria-label="Notifications"
                            aria-owns={open ? "menu-list" : null}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                            className={classes.buttonLink}
                        >
                            <Notifications className={classes.links}/>
                            <span
                                className={classes.notifications}>{(this.props.reportData.ecommIssues ? this.props.reportData.ecommIssues.length : 0)
                            + (this.props.reportData.s3Issues ? this.props.reportData.s3Issues.length : 0)}</span>
                            <Hidden mdUp>
                                <p onClick={this.handleClick} className={classes.linkText}>
                                    Notification
                                </p>
                            </Hidden>
                        </IconButton>
                    </Target>
                    <Popper
                        placement="bottom-start"
                        eventsEnabled={open}
                        className={
                            classNames({[classes.popperClose]: !open}) +
                            " " +
                            classes.pooperResponsive
                        }
                    >
                        <ClickAwayListener onClickAway={this.handleClose}>
                            <Grow
                                in={open}
                                id="menu-list"
                                style={{transformOrigin: "0 0 0"}}
                            >
                                <Paper className={classes.dropdown}>
                                    <MenuList role="menu">
                                        {
                                            this.props.reportData.ecommIssues &&
                                            this.props.reportData.ecommIssues.map((line) =>
                                                <MenuItem
                                                    onClick={this.handleClose}
                                                    className={classes.dropdownItem}
                                                >
                                                    {line}
                                                </MenuItem>
                                            )
                                        };

                                        {
                                            this.props.reportData.s3Issues &&
                                            this.props.reportData.s3Issues.map((line) =>
                                                <MenuItem
                                                    onClick={this.handleClose}
                                                    className={classes.dropdownItem}
                                                >
                                                    {line}
                                                </MenuItem>
                                            )
                                        };
                                    </MenuList>
                                </Paper>
                            </Grow>
                        </ClickAwayListener>
                    </Popper>
                </Manager>
                <Manager style={{display: "inline-block"}}>
                    <Target>
                        <IconButton
                            color="inherit"
                            aria-label="Person"
                            className={classes.buttonLink}

                            aria-owns={openLogout ? "menu-list" : null}
                            aria-haspopup="true"
                            onClick={this.handleClickLogout}
                        >
                            <Person className={classes.links}/>
                            <Hidden mdUp>
                                <p onClick={this.handleClickLogout} className={classes.linkText}>Profile</p>
                            </Hidden>
                        </IconButton>
                    </Target>
                    <Popper
                        placement="bottom-start"
                        eventsEnabled={openLogout}
                        className={
                            classNames({[classes.popperClose]: !openLogout}) +
                            " " +
                            classes.pooperResponsive
                        }
                    >
                        <ClickAwayListener onClickAway={this.handleClose}>
                            <Grow
                                in={openLogout}
                                id="menu-list-2"
                                style={{transformOrigin: "0 0 0"}}
                            >
                                <Paper className={classes.dropdown}>
                                    <MenuList role="menu">
                                        <MenuItem
                                            onClick={this.handleLogout}
                                            className={classes.dropdownItem}
                                        >
                                            Logout
                                        </MenuItem>
                                    </MenuList>
                                </Paper>
                            </Grow>
                        </ClickAwayListener>
                    </Popper>
                </Manager>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        reportData: state.reportState.reportData
    }
};

const HeaderLinks = connect(
    mapStateToProps
)(HeaderLinksPage);

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx